import React, { Component } from 'react';
import Header from './common/header/header.component.jsx';
import Footer from './common/footer/footer.component.jsx';

class AppSignerToken extends Component {

	constructor(props) {
		super(props);
	}

	render(){
		return (
			<div className="ds-wrapper">
				<Header type='signertoken' />
					{this.props.children}
				<Footer type='signertoken' />
			</div>
		);
	}
}

export default AppSignerToken